<template>
  <portlet
      :icon="'fal fa-user-clock'"
      :title="'Poule'"
      :actionsBlock="false"
  >

    <template slot="portletBody">
      <div v-if="getData.length">
        <datatables
            :tableClass="'existing-user-pools'"
            :rows="getData"
            :columns="getColumns()"
            tableID="sms-dt"
            routerLinkClass="dt-router-link"
            :tableInitOptions="tableInitOptions"
        ></datatables>
      </div>
      <div v-else>
        Er zijn nog geen kandidaten in de poule van dit bedrijf.
      </div>
    </template>
  </portlet>
</template>


<script>
import {mapGetters} from "vuex";

export default {
  props: ["customer"],
  components: {},
  data() {
    return {
      sickDays: [],
      usersInPool: [],
      tableInitOptions: {
        destroy: true,
        responsive: true,
        details: false,
        select: true,
        bAutoWidth: false,
        language: {
          searchPlaceholder: 'Zoeken...',
          sProcessing: 'Bezig...',
          sLengthMenu: '_MENU_',
          sZeroRecords: 'Geen resultaten gevonden',
          sInfo: '_START_ tot _END_ van _TOTAL_ resultaten',
          sInfoEmpty: 'Geen resultaten om weer te geven',
          sInfoFiltered: ' (gefilterd uit _MAX_ resultaten)',
          sInfoPostFix: '',
          sSearch: '',
          sEmptyTable: 'Geen resultaten aanwezig in de tabel',
          sInfoThousands: '.',
          sLoadingRecords: 'Een moment geduld aub - bezig met laden...',
          oPaginate: {
            sFirst: 'Eerste',
            sLast: 'Laatste',
            sNext: 'Volgende',
            sPrevious: 'Vorige'
          },
          oAria: {
            sSortAscending: ': activeer om kolom oplopend te sorteren',
            sSortDescending: ': activeer om kolom aflopend te sorteren'
          }
        },
        drawCallback() {
          var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
          pagination.toggle(this.api().page.info().pages > 1);
        }
      }
    };
  },
  methods: {
    getColumns() {
      let self = this;
      return [
        {
          data: null, name: 'Gebruiker', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            if (data.candidateId) {
              return '<a data-to="/candidates/' + data.candidateId + '" class="dt-router-link">' + data.candidate + '</a>'
            }
            return data.candidate ? data.candidate : '';
          }
        },
        {
          data: null, name: 'Ziek', visible: true, searchable: false, responsivePriority: 1,
          render(data) {
            return data.sick ? 'Ja' : 'Nee'
          }
        },
        {
          data: null, name: 'Startdatum huidige ziekte', visible: true, searchable: true, responsivePriority: 4,
          render(data) {
            return data.startCurrentSickDate ? moment(data.startCurrentSickDate).format('DD-MM-YYYY') : ''
          }
        },
        {
          data: null, name: 'Einddatum huidige ziekte', visible: true, searchable: true, responsivePriority: 2,
          render(data) {
            return data.endCurrentSickDate ? moment(data.endCurrentSickDate).format('DD-MM-YYYY') : ''
          }
        },
        {
          data: null,
          name: 'Startdatum toekomstig ziekteverlof',
          visible: true,
          searchable: true,
          responsivePriority: 4,
          render(data) {
            return data.startFutureSickDate ? moment(data.startFutureSickDate).format('DD-MM-YYYY') : ''
          }
        },
        {
          data: null, name: 'Geplaatst', visible: true, searchable: false, responsivePriority: 1,
          render(data) {
            return data.placed ? 'Ja' : 'Nee'
          }
        },
        {
          data: null, name: 'Einddatum huidige plaatsing', visible: true, searchable: true, responsivePriority: 2,
          render(data) {
            return data.endDateCurrentPlacement ? moment(data.endDateCurrentPlacement).format('DD-MM-YYYY') : ''
          }
        },
        {
          data: null, name: 'Startdatum toekomstige plaatsting', visible: true, searchable: true, responsivePriority: 3,
          render(data) {
            return data.startDateFuturePlacement ? moment(data.startDateFuturePlacement).format('DD-MM-YYYY') : ''
          }
        },
      ]
    },
    async getSickDay(candidateId) {
      // Get the sickdays of a candidate by id
      // Because its a sub collection it needs to go this way
      return new Promise(async (resolve) => {
        const sickDays = (await this.$FB.collection('candidates').doc(candidateId).collection('sickDays').get()).docs.map(doc => {
          return doc.data()
        });
        resolve({
          candidateId,
          sickDays
        })
      })
    },
    async getSickDays(candidateIds) {
      candidateIds.forEach(candidateId => {
        this.getSickDay(candidateId).then(sickdays => {
          this.sickDays.push(sickdays)
        })
      })
    },
    getSicknessStatisticsOfCandidate(candidateId) {
      let currentSickStartDate = '';
      let currentSickEndDate = '';
      let futureSickLeaveStartDate = '';
      const candidate = this.getCandidate(candidateId);
      const sickDates = _.find(this.sickDays, {'candidateId': candidateId});
      if (sickDates) {
        // Save some performance by checking if he's currently sick
        if (candidate.sick) {
          const currentSickDate = _.find(sickDates.sickDays, sickDate => {
            return moment().isSameOrAfter(moment(sickDate.startDate, 'YYYY-MM-DD')) && (!sickDate.endDate || moment().isSameOrBefore(moment(sickDate.endDate, 'YYYY-MM-DD')))
          });
          currentSickStartDate = currentSickDate.startDate;
          currentSickEndDate = currentSickDate.endDate;
        }

        const futureSickLeave = _.orderBy(_.filter(sickDates.sickDays, sickDate => {
          return moment(sickDate.startDate, 'YYYY-MM-DD').isAfter(moment())
        }), ['startDate', 'asc']);
        if (futureSickLeave.length) {
          futureSickLeaveStartDate = _.first(futureSickLeave).startDate;
        }
      }
      return {
        currentSickStartDate,
        currentSickEndDate,
        futureSickLeaveStartDate
      }
    },
    getPlacementStatisticsOfCandidate(candidateId) {
      const currentPlacement = _.find(this.getCandidatePlacements(candidateId), placement => {
        return moment().isSameOrAfter(moment(placement.startDate, 'YYYY-MM-DD')) && (!placement.endDate || moment().isBefore(moment(placement.endDate, 'YYYY-MM-DD')))
      })
      let futurePlacementStartDate = '';
      const futurePlacements = _.orderBy(_.filter(this.getCandidatePlacements(candidateId), placement => {
        return moment(placement.startDate, 'YYYY-MM-DD').isAfter(moment())
      }), ['startDate', 'asc']);
      if (futurePlacements.length) {
        futurePlacementStartDate = _.first(futurePlacements).startDate;
      }
      return {
        currentPlacement,
        futurePlacementStartDate
      }
    },
    summarizePoolData(pool) {
      const candidate = this.getCandidate(pool.candidateId);
      const sickDayStatistics = this.getSicknessStatisticsOfCandidate(candidate.id);
      const placementStatistics = this.getPlacementStatisticsOfCandidate(candidate.id);

      return {
        candidateId: candidate ? candidate.id : '',
        candidate: candidate ? `${candidate.firstName} ${candidate.lastName}` : 'test',
        sick: candidate ? candidate.sick : false,
        startCurrentSickDate: sickDayStatistics.currentSickStartDate,
        endCurrentSickDate: sickDayStatistics.currentSickEndDate,
        startFutureSickDate: sickDayStatistics.futureSickLeaveStartDate,
        placed: placementStatistics.currentPlacement ? true : false,
        endDateCurrentPlacement: placementStatistics.currentPlacement ? placementStatistics.currentPlacement.endDate : '',
        startDateFuturePlacement: placementStatistics.futurePlacementStartDate
      };
    }
  },
  watch: {
    // Checks new added users and fetch their sickday as well
    // But prevents fetching the same docs over and over
    usersInPool: function (newCandidateIdList, oldCandidateIdList) {
      const newPlacedCandidateIds = _.difference(_.uniq(newCandidateIdList), _.uniq(oldCandidateIdList));
      newPlacedCandidateIds.forEach(newPlacedCandidateId => {
        this.getSickDay(newPlacedCandidateId).then(sickdays => {
          this.sickDays.push(sickdays)
        })
      });
    }
  },
  computed: {
    ...mapGetters('pools', ['getPoolsOfCustomerId']),
    ...mapGetters('candidates', ['getCandidate']),
    ...mapGetters('placements', ['getCandidatePlacements']),
    getData() {
      const poolsOfCustomerId = _.filter(this.getPoolsOfCustomerId(this.customer.id), {'archived': false});
      this.usersInPool = _.map(poolsOfCustomerId, 'candidateId');
      return _.map(poolsOfCustomerId, this.summarizePoolData);
    }
  },
};
</script>
<style lang="scss" scoped>
.edit-part {
  display: grid;
  grid-template-columns: 1fr 200px;
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 10px;
}

.edit-part-container {
  margin-bottom: 10px;
}

.save-pool-btn {
  height: fit-content;
  align-self: start;
}
</style>